import React from "react";
import "./css/settings.css";

const Settings = () => {
  return (
    <div className="settings-container">
      <div className="settings-header">
        <h1 className="settings-title">Settings</h1>
        <p className="settings-subtitle">Manage your account preferences and security settings</p>
      </div>

      <div className="settings-grid">
        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Profile Settings</h2>
          </div>
          <div className="settings-card-body">
            <p>Update your personal details, contact information, and language preferences.</p>
            <button className="btn btn-primary settings-button">Edit Profile</button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Notifications</h2>
          </div>
          <div className="settings-card-body">
            <p>Configure how and when you receive notifications from the system.</p>
            <button className="btn btn-primary settings-button">Notification Preferences</button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Accessibility</h2>
          </div>
          <div className="settings-card-body">
            <p>Adjust display settings for better readability and accessibility.</p>
            <button className="btn btn-primary settings-button">Accessibility Options</button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Security</h2>
          </div>
          <div className="settings-card-body">
            <p>Manage your password and account security settings.</p>
            <button className="btn btn-primary settings-button">Security Settings</button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Privacy</h2>
          </div>
          <div className="settings-card-body">
            <p>Control your data sharing and privacy preferences.</p>
            <button className="btn btn-primary settings-button">Privacy Options</button>
          </div>
        </div>

        <div className="settings-card">
          <div className="settings-card-header">
            <h2>Help & Support</h2>
          </div>
          <div className="settings-card-body">
            <p>Get help with using the system or contact support.</p>
            <button className="btn btn-primary settings-button">Get Help</button>
          </div>
        </div>
      </div>
    </div>
  );
};

export default Settings;